var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddLightPole = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.952,
    height: 12.467,
    viewBox: "0 0 17.952 12.467",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-23.022 -2.245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.378,2.245h-9.2V3.79a13.093,13.093,0,0,0-5.027,1.3V2.245H23.022V14.59h1.125V6.354A11.391,11.391,0,0,1,29.174,4.9V6.563h1.388C30.99,7.816,32.837,8.7,35.19,8.7s4.2-.888,4.63-2.141h1.154V4.841A2.6,2.6,0,0,0,38.378,2.245ZM35.19,7.579a4.921,4.921,0,0,1-3.323-1.016h6.647A4.922,4.922,0,0,1,35.19,7.579Zm4.659-2.141H30.3V3.37h8.079a1.473,1.473,0,0,1,1.471,1.471Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.974,11.869H39.131V10.026h-1v1.843H36.288v1h1.843v1.843h1V12.869h1.843Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddLightPole);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add-light-pole.1492606e6fbeb048407d439f28466164.svg";